import React, { useCallback, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SmartDiaryEntry } from '../type';
import { SimpleList } from '../SmartDiaryList/SimpleList';
import { useTimesheetSyncError, SyncError } from './hooks';
import { UncategorizedError } from './UncategorizedError';

type ErrorDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  lastSyncErrors: SyncError[];
  smartEntriesByDay: Record<string, SmartDiaryEntry[]>;
};
export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  open,
  setOpen,
  lastSyncErrors,
  smartEntriesByDay
}: ErrorDialogProps) => {
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const entries = useMemo(() => Object.values(smartEntriesByDay).flat(), [
    smartEntriesByDay
  ]);

  const {
    title,
    isKnownError,
    hasTimesheetReadOnlyError,
    description,
    uncategorizedErrors,
    erroredEntries
  } = useTimesheetSyncError(lastSyncErrors, entries);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {isKnownError ? <span>{description}</span> : null}
        </DialogContentText>
        {isKnownError && !hasTimesheetReadOnlyError ? (
          <SimpleList smartEntries={erroredEntries} />
        ) : null}
        {!hasTimesheetReadOnlyError &&
        uncategorizedErrors &&
        uncategorizedErrors.length ? (
          <UncategorizedError
            errors={uncategorizedErrors}
            smartEntries={erroredEntries}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          <FormattedMessage id="smartDiary.errorDialog.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
